import React from 'react';
import './header.scss';
import logo from '../../assets/icons/logo-crediautos.svg';

function Header() {
	return (
		<header>
			<div className="header-container">
				<img src={logo} alt="logo" />
			</div>
		</header>
	);
}

export default Header;
